import Vue from 'vue'
import Vuex from 'vuex'
import Api from "@/api/index";
import { getDeviceInfo, getSystemInfo } from "@utils/index.js";
const env = window.ENV == "production" ? true : false;

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isShowMask: false,
    isShowDialogFollow: false,
    isShowDialogPhone: false,
    isShowDialogGuid: false,
    isShowDialogPrize: false,
    isShowDialogShare: false,
    isShowDialogAddress: false,
    isShowDialogTicketHelp: false,
    isShowDialogPrizeRecord: false,

    isShowPopupRole: false,
    isShowPopupQuickRole: false,

    isShowDialogEffect: false,
    isShowDialogRedEffect: false,
    isShowDialogReadEffect: false,
    isShowDialogReadTip: false,
    isShowDialogAnswerEffect: false,
    isShowDialogAnswerTip: false,
    isShowDialogNoNum: false,
    isShowDialogAnswerError: false,

    dialogNum: 0,

    /** 用户信息 */
    userInfo: {
      guid: '',//用户guid
      server_id: '',//游戏区服id
      role_id: '',//游戏角色id
      auth_token: '',//渠道中台(微信)授权标识
      read_time: 0, // 阅读时间
      read_progress: 0, // 阅读进度
      local_begin_time: 0 // ---------- 用户环境的开始时间
    },
    roleList: [],
    wx_appid: '',
    wx_scope: 'snsapi_base',
    module_cfg: [],//页面的配置
    ext_cfg: {}, // 扩展配置
    activityInfo: {},
    module_id: '',
    curPrize: {},//当前抽中的奖品
    address: {
      status: true,//地址状态，true：编辑,false:展示
    },
    flag: false
  },
  mutations: {
    OPEN_DIALOG(state, type) {
      if (this.state.flag) return;
      if (state[`isShowDialog${type}`]) return;
      this.state.flag = true;
      state.dialogNum++;
      state[`isShowDialog${type}`] = true;
      state.isShowMask = true;
      document.querySelector("body").setAttribute("style", "overflow:hidden;");
      if (state.dialogNum > 1) {
        document.getElementById("mask").setAttribute("style", "z-index:600;");
      }
      setTimeout(() => { this.state.flag = false; }, 500)
    },
    CLOSE_DIALOG(state, type) {
      state.dialogNum--;
      state[`isShowDialog${type}`] = false;
      if (state.dialogNum < 1) {
        state.isShowMask = false;
        document.body.removeAttribute("style");
        document.getElementById("mask").removeAttribute("style");
      } else {
        document.getElementById("mask").setAttribute("style", "z-index:500;");
      }
    },
    OPEN_POPUP(state, type) {
      state[`isShowPopup${type}`] = true;
      document.querySelector("body").setAttribute("style", "overflow:hidden;");
    },
    CLOSE_POPUP(state, type) {
      state[`isShowPopup${type}`] = false;
      document.body.removeAttribute("style");
    },
    UPDATE_MODULE_CFG(state, arr) {
      if (Object.prototype.toString.call(arr) === '[object Array]') {
        state.module_cfg = arr;
      }
    },
    UPDATE_USERINFO(state, info) {
      if (Object.prototype.toString.call(info) === '[object Object]') {
        state.userInfo = {
          ...state.userInfo,
          ...info
        }
      }
    },
    UPDATE_ROLELIST(state, lists) {
      if (Object.prototype.toString.call(lists) === '[object Array]') {
        state.roleList = lists;
      }
    },
    UPDATE_EXT_CFG(state, ext) {
      if (Object.prototype.toString.call(ext) === '[object Object]') {
        state.ext_cfg = {
          ...state.ext_cfg,
          ...ext
        }
      }
    },
    UPDATE_ACTIVITY_INFO(state, info) {
      if (Object.prototype.toString.call(info) === '[object Object]') {
        state.activityInfo = {
          ...state.activityInfo,
          ...info
        }
      }
    },
    UPDATE_MODULE_ID(state, module_id) {
      state.module_id = module_id;
    },
    UPDATE_PRIZE(state, prize) {
      if (Object.prototype.toString.call(prize) === '[object Object]') {
        state.curPrize = prize
      }
    },
    UPDATE_ADDRESS(state, info) {
      if (Object.prototype.toString.call(info) === '[object Object]') {
        state.address = {
          ...state.address,
          ...info
        }
      }
    },
  },
  actions: {
    async INIT_CONFIG(context) {
      //1. 进入页面获取appid
      let { code, data } = await Api.config.initAuth()
      if (code !== 0) return;
      context.state.wx_appid = data.wx_appid;
      if (data?.scope && data?.scope != '') {
        context.state.wx_scope = data.scope;
      }

      //2. 请求授权
      window.wechatSDK = new window.kutils.wechat(data.wx_appid, env);
      context.dispatch('INIT_ACTIVITY');
      // context.dispatch('WECHAT_AUTH')
    },
    async WECHAT_AUTH(context) {
      //3. 授权成功拿到token
      let data = await window.wechatSDK.auth(window.location.href, context.state.wx_scope);
      if (data && data?.authorize_token) {
        context.state.userInfo.auth_token = data.authorize_token;
        context.dispatch('INIT_ACTIVITY');
        context.dispatch('TRACK', 1)
      }

    },
    async INIT_ACTIVITY(context) {
      let { code, data } = await Api.config.initActivity();
      if (code !== 0) return;
      context.commit('UPDATE_MODULE_CFG', data.module_cfg)
      context.commit('UPDATE_EXT_CFG', data.ext_cfg)
      context.commit('UPDATE_USERINFO', data.user_info)
      context.commit('UPDATE_ACTIVITY_INFO', data)

      if (data.ext_cfg?.wechat_share && window.wechatSDK) {
        let { title, img, desc, switch: share_switch } = data.ext_cfg.wechat_share;
        if (share_switch == 1) {
          //开启
          window.wechatSDK.setShare({
            title,
            desc,
            imgUrl: img
          })
        } else {
          //关闭
          window.wechatSDK.hideMenu();
        }
      }
      //头部信息
      document.title = data.activity_name
      setTimeout(() => {
        context.state.userInfo.local_begin_time = new Date().getTime();
      }, 5000);
    },
    async GET_ROLE_INFO(context) {
      let { code, data } = await Api.user.getGuidInfo({
        guid: context.state.userInfo.guid
      })
      if (code !== 0) return;
      context.commit('UPDATE_ROLELIST', data.roles)
    },
    async TRACK(context, log_type, module_id = '') {
      let { code } = await Api.log.track({
        operate: log_type,
        guid: context.state.userInfo.guid || "",
        module_id,
        ...getSystemInfo(),

      });
      if (code != 0) return;
    }
  },
  getters: {
    userInfo: state => state.userInfo,
    viewCfg: state => state.module_cfg,
    downloadUrl: (state) => {
      let osType = getDeviceInfo();
      if (osType === 1) {//安卓
        return state.activityInfo?.ar_download_url || "";
      } else if (osType === 2) {//ios
        return state.activityInfo?.ios_download_url || "";
      }
    },
    roleList: state => state.roleList,
    activityInfo: state => state.activityInfo,
    prize: state => state.curPrize
  }
})